export function checkExpiration(dataString) {
    if (!dataString) {
        return false;
    }
    if (dataString === "never") {
        return true;
    }
    const data = new Date(dataString);
    data.setHours(0, 0, 0, 0);
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const ontem = new Date(hoje);
    ontem.setDate(hoje.getDate() - 2);

    return data >= ontem;
}

function stringToColor(string) {
    let hash = 0;
    let i;
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
}

export function stringAvatar(name, size) {
    return {
        sx: {
            width: size,
            height: size,
            bgcolor: stringToColor(name),
        },
        children: `${name.split(' ')[0][0]}`,
    };
}

export function friendlyDate(data) {
    var partes = data.split("-");
    var ano = partes[0];
    var mes = partes[1];
    var dia = partes[2];
    var novaData = dia + "/" + mes + "/" + ano;
    return novaData;
}

export function numberToBRL(numero) {
    const numeroFormatado = numero.toFixed(2);
    const partes = numeroFormatado.split('.');
    const parteInteiraFormatada = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'R$ ' + parteInteiraFormatada + ',' + partes[1];
}

export function numberToUSD(numero) {
    const numeroFormatado = numero.toFixed(2);
    const partes = numeroFormatado.split('.');
    const parteInteiraFormatada = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'US$ ' + parteInteiraFormatada + '.' + partes[1];
}

export const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export async function pausarPorSegundos(segundos) {
    return new Promise(resolve => setTimeout(resolve, segundos * 1000));
}

export function FloatToTime(value) {
    if (value > 0) {
        const hours = Math.floor(value / 3600);
        const minutes = Math.floor((value % 3600) / 60);
        const seconds = Math.floor(value % 60);
        let formattedTime;
        if (hours > 0) {
            formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        } else {
            formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        }
        return formattedTime;
    } else {
        return '00:00';
    }
}

export function SecondsToHour(seconds) {
    const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const s = String(Math.floor(seconds % 60)).padStart(2, '0');
    return `${h}:${m}:${s}`;
}

export function parseTime(timeString) {
    const [h, m, s] = timeString.split(':').map(Number);
    return (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
};

const parseDateFlexible = (dateString) => {
    if (!dateString) return new Date(0);
    const parsed = new Date(dateString);
    if (!isNaN(parsed)) return parsed;
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        const [day, month, year] = dateString.split('/');
        return new Date(`${year}-${month}-${day}`);
    }
    return new Date(0);
};

export const compareDates = (objectA, objectB) => {
    const dateA = parseDateFlexible(objectA.data);
    const dateB = parseDateFlexible(objectB.data);
    return dateB - dateA;
}

export const sanitizeNumber = (value, fallback = 0) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : fallback;
};

export const removeUndefinedValues = (obj) => {
    if (Array.isArray(obj)) {
        return obj
            .map((item) => removeUndefinedValues(item))
            .filter((item) => item !== undefined && item !== null && !(typeof item === 'number' && Number.isNaN(item)));
    } else if (obj && typeof obj === "object") {
        return Object.fromEntries(
            Object.entries(obj)
                .map(([key, value]) => [key, removeUndefinedValues(value)])
                .filter(([_, value]) => value !== undefined && value !== null && !(typeof value === 'number' && Number.isNaN(value)))
        );
    }
    return obj;
};

export const safePlay = (player) => {
    if (!player || typeof player.play !== 'function') return;
    const playPromise = player.play();
    if (playPromise !== undefined) {
        playPromise.catch(() => { });
    }
};

export function colorWithAlpha(color, alpha) {
    // Se já for rgba, só troca o alpha
    if (color.startsWith('rgba')) {
        return color.replace(/rgba\(([^,]+),([^,]+),([^,]+),([^)]+)\)/, (_, r, g, b) => {
            return `rgba(${r},${g},${b},${alpha})`;
        });
    }
    // Se for rgb, converte pra rgba
    if (color.startsWith('rgb(')) {
        return color.replace(/rgb\(([^,]+),([^,]+),([^,]+)\)/, (_, r, g, b) => {
            return `rgba(${r},${g},${b},${alpha})`;
        });
    }
    // Se for hex
    if (color[0] === '#') {
        let c = color.substring(1);
        if (c.length === 3) c = c.split('').map(x => x + x).join('');
        const num = parseInt(c, 16);
        const r = (num >> 16) & 255;
        const g = (num >> 8) & 255;
        const b = num & 255;
        return `rgba(${r},${g},${b},${alpha})`;
    }
    // Cores nomeadas: confia, porque o canvas converte pra rgb automaticamente
    // Mas não dá pra customizar o alpha (limitação). Aqui retorna preto por segurança.
    return `rgba(0,0,0,${alpha})`;
}

export const parseTimeInput = (text) => {
    if (!text) return 0;

    let h = 0,
        m = 0,
        s = 0,
        fraction = 0;

    const clean = text.replace(/[^\d:.]/g, "");
    const parts = clean.split(":");

    const parseSeconds = (value) => {
        const secParts = value.split(".");
        const seconds = parseInt(secParts[0]) || 0;
        const frac = secParts[1] ? parseFloat(`0.${secParts[1]}`) : 0;
        return [seconds, frac];
    };

    if (parts.length === 3) {
        h = parseInt(parts[0]) || 0;
        m = parseInt(parts[1]) || 0;
        [s, fraction] = parseSeconds(parts[2]);
    } else if (parts.length === 2) {
        m = parseInt(parts[0]) || 0;
        [s, fraction] = parseSeconds(parts[1]);
    } else {
        [s, fraction] = parseSeconds(parts[0]);
    }

    return h * 3600 + m * 60 + s + fraction;
};

export function FloatToTimeMilliseconds(value) {
    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const seconds = Math.floor(value % 60);
    const microseconds = Math.floor((value % 1) * 1_000_000); // 6 casas decimais
    return `${String(hours).padStart(2, "0")}:` +
        `${String(minutes).padStart(2, "0")}:` +
        `${String(seconds).padStart(2, "0")}.` +
        `${String(microseconds).padStart(6, "0")}`;
}
